import { select, Store } from "@ngrx/store";
import { AppState } from "../../reducers";
import { BaseDataSource, QueryResultsModel } from "../../_base/crud";
import { selectLandAdjustmentQueryResult, selectLandAdjustmentsPageLoading, selectLandAdjustmentsShowInitWaitingMessage } from "../_selectors/land-adjustment.selectors";

export class LandAdjustmentsDataSource extends BaseDataSource {
    trashed = 0;

    constructor(private store: Store<AppState>) {
        super();

        this.loading$ = this.store.pipe(
            select(selectLandAdjustmentsPageLoading)
        );

        this.isPreloadTextViewed$ = this.store.pipe(
            select(selectLandAdjustmentsShowInitWaitingMessage)
        );

        this.store.pipe(
            select(selectLandAdjustmentQueryResult)
        ).subscribe((response: QueryResultsModel) => {
            this.paginatorTotalSubject.next(response.totalCount);
            this.entitySubject.next(response.items);
        })
        
    }
}